<!-- <div *ngIf="showProgressBar">
  <mat-progress-bar
    class="example-margin"
    [color]="color"
    [mode]="mode"
    [value]="value">
  </mat-progress-bar><br><br>
  <mat-label>Voting in progress </mat-label>
  <mat-label>{{value}} %</mat-label>
</div> -->
<div class="execute-header-container">
  <div id="bloc1">
    <mat-icon> table_chart</mat-icon><span class="aligned-with-icon">Polls</span>
  </div >
    <div  class="execute-block2">
      <mat-form-field class="example-form-field" appearance="fill">
        <mat-label>Search</mat-label>
        <mat-date-range-input
          [formGroup]="campaignOne"
          [rangePicker]="campaignOnePicker"
          [comparisonStart]="campaignOne.value.start"
          [comparisonEnd]="campaignOne.value.end">
          <input matStartDate placeholder="Start date" formControlName="start" (dateChange)="filteredpollHistoryListOnBasisOfDateRange()">
          <input matEndDate placeholder="End date" formControlName="end" (dateChange)="filteredpollHistoryListOnBasisOfDateRange()">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="campaignOnePicker"></mat-datepicker-toggle>
        <mat-date-range-picker #campaignOnePicker></mat-date-range-picker>
      </mat-form-field>

    </div>
  
  
      
</div>

<!-- <mat-spinner style="margin: auto;" *ngIf="showSpinner; else showContent" ></mat-spinner>

<ng-template #showContent>
  <div>
    <div *ngIf="userRole =='admin'">
      <h4 style="margin: 1vw;">Select a phone number and click on execute button to Execute poll.</h4>
      <div style="margin: 1vw;">
        <mat-form-field appearance="fill">
          <mat-label>Select Phone Number</mat-label>
          <mat-select [(ngModel)]="phone" >
            <mat-option *ngFor="let data of phoneNumberObjectList" [value]="data.phone">{{data.phone}} : {{data.description}}</mat-option>
          </mat-select>
        </mat-form-field>&nbsp;
        <button (click)= "executeNow()" mat-raised-button >Execute Now</button>
      </div>
    </div>
    
    <h2 style="padding-left: 1rem;">
      {{pollInfo.name}}
    </h2>
    <table  style="margin: 10px; width:95%;" class="table table-striped table-hover" data-row-style="rowStyle">
      <thead>
        <tr class="t-header">
          
          <th class="" scope="col">
            <div title="Date">Execution Time</div>
          </th>
          <th class="" scope="col">
              <div title="Status">Poll Status </div>
          </th>
          <th class="" scope="col">
              <div title="Result">Result </div>
          </th>
          <th class="" scope="col" *ngIf="userRole =='admin'">
            <div title="Delete">Delete </div>
        </th>
        </tr>
      </thead>
      <tbody>
          <tr *ngFor="let data of filteredpollHistoryList let indexOfelement=index;">
            
            <td>
                {{data.date}} : {{data.time}}
            </td>
            <td>
              {{data.completed}}
            </td>
            <td>
              <mat-icon (click)= "openDialog(data.id)">equalizer</mat-icon>
            </td>
            <td *ngIf="userRole =='admin'">
              <mat-icon (click)="deletePollHistory(data.id)">delete</mat-icon>
            </td>
          
          </tr>
      </tbody>
  </table>
  </div>
</ng-template> -->

<mat-spinner style="margin: auto;" *ngIf="showSpinner" ></mat-spinner>

<div class="mat-elevation-z8" style="padding: 2vw;" [hidden]="showSpinner">
  <div *ngIf="userRole =='admin'">
    <h4 style="margin: 1vw;">Select a phone number and click on execute button to Execute poll.</h4>
    <div style="margin: 1vw;">
      <mat-form-field appearance="fill">
        <mat-label>Select Phone Number</mat-label>
        <mat-select [(ngModel)]="phone" >
          <mat-option *ngFor="let data of phoneNumberObjectList" [value]="data.phone">{{data.phone}} : {{data.description}}</mat-option>
        </mat-select>
      </mat-form-field>&nbsp;
      <button (click)= "executeNow()" mat-raised-button >Execute Now</button>
    </div>
  </div>
  
  <h2 style="padding-left: 1rem;">
    {{pollInfo?.name}}
  </h2>
  <table mat-table [dataSource]="dataSource" matSort>
  
      <ng-container matColumnDef="created_at">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Execution Time </th>
      <td mat-cell *matCellDef="let row"> {{row.created_at | date:'M/d/yy, h:mm a'}} </td>
      </ng-container>

      <ng-container matColumnDef="completed">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Poll Status </th>
      <td mat-cell *matCellDef="let row" > {{row.completed}} </td>
      </ng-container>
  
      <ng-container matColumnDef="updated_at">
      <th mat-header-cell *matHeaderCellDef> Result </th>
      <td mat-cell *matCellDef="let row" > <mat-icon (click)= "openDialog(row.id)">equalizer</mat-icon> </td>
      </ng-container>
  
      <ng-container matColumnDef="id" >
      <th mat-header-cell *matHeaderCellDef> Delete </th>
      <td mat-cell *matCellDef="let row"> <mat-icon (click)="deletePollHistory(row.id)">delete</mat-icon> </td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">No data matching the filter {{searchText}}</td>
      </tr>
  </table>
    
    <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
</div>